import { defineMessages } from 'react-intl';

const messages: {
	debugLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	debugLabel: {
		id: 'chatHistory.storeAssistant.debugLabel',
		defaultMessage: 'Debug response',
		description:
			"Button label displayed on a debug button in the message footer within the AI conversation interface that opens debugging information for an AI response. Shown as the text on a button. When clicked, it displays technical debugging details about how the AI generated the response, such as prompts, model parameters, or processing steps. The purpose is to provide developers and power users with technical information to help diagnose issues or understand the AI's reasoning process.",
	},
});

export default messages;
